import { render } from "./radio-buttons.vue?vue&type=template&id=46cc438b"
import script from "./radio-buttons.vue?vue&type=script&lang=js"
export * from "./radio-buttons.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__